export type HeaderMenuItem = 'questions' | 'dashboard' | 'mock';

function pathOf(url: string): string {
  const raw = url || '/';
  const withoutQuery = raw.split('?')[0].split('#')[0];
  if (withoutQuery.length > 1 && withoutQuery.charAt(withoutQuery.length - 1) === '/') {
    return withoutQuery.slice(0, -1);
  }
  return withoutQuery || '/';
}

export function headerMenuFromUrl(url: string): HeaderMenuItem {
  const path = pathOf(url);
  if (path === '/mock' || path.indexOf('/mock/') === 0) {
    return 'mock';
  }
  if (path === '/dashboard' || path.indexOf('/dashboard/') === 0) {
    return 'dashboard';
  }
  return 'questions';
}

export function headerMenuHidden(url: string): boolean {
  const path = pathOf(url);
  return path === '/profile' || path.indexOf('/profile/') === 0;
}
